<template>
  <div v-if="hasExclusionClash" class="unit-card__alert-bottom prereq">
    <span class="unit-card__alert-bottom-content" :id="`tooltip-prereq-alert-${code}`">
      {{ __("label:exclusion conflict") }} <i class="far fa-info-circle"></i>
    </span>
    <button type="button" class="unit-card__alert-bottom-action"
      v-on:click="openSlideOut({component: slideOutComponent, componentProperties: slideOutComponentProperties})">
      See details
    </button>

    <b-tooltip :target="`tooltip-prereq-alert-${code}`" triggers="hover" placement="right" noninteractive>
      {{ __("info:exclusion conflict") }}
    </b-tooltip>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import inputBuilder from 'common/helpers/input-builder.js'
import exclusionValidator from 'common/helpers/exclusion-validator.js'
import SlideOutUnitDetailsView from './slide-out-tree-view/SlideOutUnitDetailsView.vue'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    firstLevelTitle: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      slideOutComponent: SlideOutUnitDetailsView,
      slideOutComponentProperties: {
        relationship: this.item.relationship,
        location: this.item.location,
        firstLevelTitle: this.item.firstLevelTitle
      }
    }
  },
  methods: {
    ...mapMutations('global', {
      openSlideOut: 'openSlideOut'
    })
  },
  computed: {
    ...mapGetters({
      selectedUnitCodes: 'units/getSelectedUnitCodes'
    }),
    convertedExclusions() {
      return inputBuilder.convertRequisites(this.item.relationship.unit.requisites, 'Exclusion')
    },
    convertedEquivalents() {
      return inputBuilder.convertRequisites(this.item.relationship.unit.requisites, 'Equivalent')
    },
    hasExclusionClash() {
      return (this.convertedExclusions && exclusionValidator.exclusionClashTest(this.item.relationship.code, this.selectedUnitCodes, this.convertedExclusions))
        || (this.convertedEquivalents && exclusionValidator.exclusionClashTest(this.item.relationship.code, this.selectedUnitCodes, this.convertedEquivalents))
    }
  }
}
</script>
